/* global $ */

import DmcImage from './DmcImage';

class PageDmcDetail {
  constructor(mainApp) {
    this.$window = $(window);
    this.mainApp = mainApp;
    this.dmcImage = null;

    if ($('.DmcImage').length) {
      this.dmcImage = new DmcImage($('.DmcImage'));
    }
  }
  onLoadWindow() {}
  onWindowResize() {}
  onWindowScroll() {}
  destroy() {
    if (this.dmcImage) {
      this.dmcImage.destroy();
      this.dmcImage = null;
    }
  }
}

export default PageDmcDetail;
